import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import GridGenres from '../../../content/grid/GridGenres';

import useCustomGenres from '../hooks/useCustomGenres';

function ConnectedGenresManager({ url, id, name, dimension }) {
  const { width } = dimension;
  const { formatTitle, getMainGenre, isUpdated } = useCustomGenres();

  const customOrderFilter = (base, x, i) => {
    // const periodEnd = dayjs().format(`YYYY-MM`);
    const year = dayjs().format(`YYYY`);
    const lastYear = year - 1;
    let mainGenre = getMainGenre(x.genres, x.slug);

    if (mainGenre) {
      // console.log('before', i, x.id, x.name.toLowerCase(), '---', mainGenre.name, '---', mainGenre.id, '---', name, '---', id,  x.publish_date, x.change_date, x)

      if (x.name && x.name.toLowerCase().includes('independent') && x.publish_date && x.publish_date.includes(year))  {
        const formatData = formatTitle(x);
        formatData.category = `${formatData.name} ${mainGenre.name}`;
        formatData.isUpdated = isUpdated(formatData.category, x.change_date)
        base.push(formatData);

     } else if (x.name && x.name.toLowerCase().includes('best new') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear)) /*(x.change_date.includes(dayjs().subtract(30, 'day').format(`YYYY-MM`)) || x.change_date.includes(periodEnd))*/ ) {
          const formatData = formatTitle(x, true);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name === formatData.name)) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('shortlist')
        && (mainGenre.id === id)
        && x.change_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear)) /*(x.publish_date.includes(dayjs().subtract(30, 'day').format(`YYYY-MM`)) || x.publish_date.includes(dayjs().subtract(60, 'day').format(`YYYY-MM`)) || x.publish_date.includes(periodEnd))*/) {
          const formatData = formatTitle(x, true);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'The ' + formatData.name;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('floor essen') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'Dancefloor Essentials';
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('closing') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('after hour') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'After Hours Essentials';
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('crate') 
        && (mainGenre.id === id)
        && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('secret') 
        && (mainGenre.id === id)
        && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      }
    } else {
      // console.log('no genre', i, x.id, x.name.toLowerCase(), '---', x);
      if (x.name && x.name.toLowerCase().includes('independent') && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
        const formatData = formatTitle(x);
        formatData.category = `${formatData.name}`;
        if (!base.some( y => y.name.includes(formatData.name))) {
          formatData.isUpdated = isUpdated(formatData.category, x.change_date)
          base.push(formatData);
        }
      }
    }

    return base;
  }

  return (
    <>
      <GridGenres title={`Dig Deeper`} id={`{B}beatport_playlists_slice_${name}`}
        width={ width - Config.SUB_SIDEBAR } rowCount={1} height={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)} rowHeight={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)}
        hasPagination={false} allTo={`${url}/playlists`} allLabel={`View All Playlists`}
        pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${id}&name=best new,shortlist,floor,closing,after hour,independent,crate,secret&updated=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
        className={`grid-chart`} customReduceFormat={customOrderFilter} showLoading={true} showTitle={true}
      />
    </>
  );
}

ConnectedGenresManager.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}

const GenresManager = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedGenresManager);

export default GenresManager;
